import moment from 'moment';
import { TdsDateCascaderValue } from '@/presentation/components/tds-form/tds-date-cascader';
import { TimeType } from '@/proto/metric';


// 列表默认时间范围参数
export const DEFAULT_ISSUE_TIME_RANGE: TdsDateCascaderValue = {
  date_type: 'event_time',
  time_window_type: TimeType.MINUTE5,
  short_cut: 'custom',
  date_value: [moment().startOf('days'), moment().endOf('days')],
};

// 默认event_time模式
export const DEFAULT_EVENT_TIME_RANGE: TdsDateCascaderValue = {
  date_type: 'event_time',
  time_window_type: TimeType.MINUTE5,
  short_cut: 'custom',
  date_value: [moment().startOf('days'), moment().endOf('days')],
};

// 时间范围参数按小时聚合且默认为发生时间
export const ISSUE_TIME_RANGE_BY_HOUR_EVENT_TIME: TdsDateCascaderValue = {
  date_type: 'event_time',
  time_window_type: TimeType.HOUR,
  short_cut: 'custom',
  date_value: [moment().startOf('days'), moment().endOf('days')],
};

// 时间范围参数按小时聚合且默认为上报时间
export const ISSUE_TIME_RANGE_BY_HOUR_REPORT_TIME: TdsDateCascaderValue = {
  date_type: 'event_time',
  time_window_type: TimeType.HOUR,
  short_cut: 'custom',
  date_value: [moment().startOf('days'), moment().endOf('days')],
};

// 指标默认event_time模式
export const SPAN_DEFAULT_EVENT_TIME_RANGE: TdsDateCascaderValue = {
  date_type: 'event_time',
  time_window_type: TimeType.DAY,
  short_cut: 'custom',
  date_value: [moment().subtract(6, 'days')
    .startOf('days'), moment().endOf('days')],
};

// 默认event_time模式
export const DEFAULT_EVENT_TIME_RANGE_DAY: TdsDateCascaderValue = {
  date_type: 'event_time',
  time_window_type: TimeType.DAY,
  short_cut: 'custom',
  date_value: [moment().startOf('days'), moment().endOf('days')],
};

// 指标默认event_time模式
export const SPAN_DEFAULT_REPORT_TIME_RANGE: TdsDateCascaderValue = {
  date_type: 'event_time',
  time_window_type: TimeType.DAY,
  short_cut: 'custom',
  date_value: [moment().subtract(6, 'days')
    .startOf('days'), moment().endOf('days')],
};


export const NUMBER_MAX_VALUE = 999999999999999;
